import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { PortalLayout } from "../../components/portal/PortalLayout";
import { StatusBadge } from "../../components/StatusBadge";
import { Package } from "lucide-react";

export default function PortalOrders() {
  const navigate = useNavigate();
  useEffect(() => { document.title = "Orders | Sambiva Trade"; }, []);
  const { data: orders = [], isLoading } = useQuery({ queryKey: ["trade-orders"], queryFn: async () => (await api.get("/trade/orders")).data });

  return (
    <PortalLayout title="Orders">
      {isLoading ? (
        <div className="text-center py-16 text-sambiva-muted">Loading…</div>
      ) : orders.length === 0 ? (
        <div className="bg-white rounded-2xl border border-sambiva-charcoal/5 p-16 text-center" data-testid="orders-empty">
          <Package className="mx-auto text-sambiva-muted mb-4" size={48} />
          <h3 className="font-serif text-2xl text-sambiva-charcoal mb-2">No orders yet</h3>
          <p className="text-sambiva-muted">Your Sambiva orders will appear here.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-sambiva-charcoal/5 overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="bg-sambiva-cream text-sambiva-muted text-left">
              <tr><th className="px-5 py-3 font-semibold">Order Number</th><th className="px-5 py-3 font-semibold">Date</th><th className="px-5 py-3 font-semibold">Items</th><th className="px-5 py-3 font-semibold">Order Value</th><th className="px-5 py-3 font-semibold">Status</th></tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} data-testid={`order-row-${o.order_number}`} onClick={() => navigate(`/portal/orders/${o.id}`)} className="border-t border-sambiva-charcoal/5 hover:bg-sambiva-cream/50 cursor-pointer">
                  <td className="px-5 py-3 font-medium text-sambiva-charcoal">{o.order_number}</td>
                  <td className="px-5 py-3 text-sambiva-muted">{new Date(o.created_at).toLocaleDateString()}</td>
                  <td className="px-5 py-3 text-sambiva-muted">{o.items.length}</td>
                  <td className="px-5 py-3 text-sambiva-charcoal font-medium">€{o.total.toFixed(2)}</td>
                  <td className="px-5 py-3"><StatusBadge status={o.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </PortalLayout>
  );
}
